import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const numberFormats = {
  'en-US': { 
    currency: {
      style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2
    }
  },
  'es-CO': {
    currency: {
      style: 'currency', currency: 'COP', currencyDisplay: 'symbol', minimumFractionDigits: 0, maximumFractionDigits: 0
    }
  },
  'es-PE': {
    currency: {
      style: 'currency', currency: 'PEN', currencyDisplay: 'symbol', minimumFractionDigits: 2, maximumFractionDigits: 2
    }
  },
  'pt-BR': {
    currency: {
      style: 'currency', currency: 'BRL', currencyDisplay: 'symbol', minimumFractionDigits: 2, maximumFractionDigits: 2
    }
  },
  'es-CL': {
    currency: {
      style: 'currency', currency: 'CLP', currencyDisplay: 'symbol', minimumFractionDigits: 0, maximumFractionDigits: 0
    }
  },
  'es-MX': {
    currency: {
      style: 'currency', currency: 'MXN', currencyDisplay: 'symbol', minimumFractionDigits: 2, maximumFractionDigits: 2
    }
  },
  'es-CR': {
    currency: {
      style: 'currency', currency: 'CRC', currencyDisplay: 'symbol', minimumFractionDigits: 0, maximumFractionDigits: 0
    }
  },
}

const HIDE_CURRENCY_SYMBOL_SUPPLIER_IDS = [21588];
const HIDE_CURRENCY_SYMBOL_SLUGS = ["pesqueira", "pesqueira-2"];

const shouldHideCurrencySymbol = () => {
  try {
    const store = require("./store").default;
    const supplier = store?.state?.customer?.supplier || {};
    const routeSlug = (window?.location?.pathname || "")
      .split("/")
      .filter(Boolean)[0]
      ?.toLowerCase();

    const supplierId = Number(supplier.id);
    const supplierSlug = String(supplier.slug || "").toLowerCase();

    return (
      HIDE_CURRENCY_SYMBOL_SUPPLIER_IDS.includes(supplierId) ||
      HIDE_CURRENCY_SYMBOL_SLUGS.includes(supplierSlug) ||
      HIDE_CURRENCY_SYMBOL_SLUGS.includes(routeSlug)
    );
  } catch (error) {
    return false;
  }
};

const i18n = new VueI18n({
  locale: "es" || "en" || "pt",
  fallbackLocale: "es" || "en",
  messages: loadLocaleMessages(),
  numberFormats: numberFormats
});

const baseN = i18n.n.bind(i18n);
i18n.n = (...args) => {
  const value = baseN(...args);
  const formatKey = typeof args[1] === "string" ? args[1] : args[1]?.key;

  if (!shouldHideCurrencySymbol() || formatKey !== "currency" || typeof value !== "string") {
    return value;
  }

  return value
    .replace(/^\s*COP\s*/i, "")
    .replace(/^\s*\$\s*/i, "")
    .replace(/\u00a0/g, " ")
    .trim();
};

export default i18n;
